import React from 'react';
import { useUserReference } from '@hooks';
export const UserNameDisplay = ({ userId }) => {
    const { fullName } = useUserReference(userId);
    return React.createElement("span", null, fullName !== null && fullName !== void 0 ? fullName : '');
};
